import request from '@/utils/request'
// 查询历史分类
export function getListCategoryHistory(params) {
  return request({
    url: '/productCategory/listCategoryHistory',
    method: 'get',
    params
  })
}
// 查询所有一级分类及子分类
export function getProductCategory(params) {
  return request({
    url: '/api/z/productCategory/list/withChildren',
    method: 'get',
    params
  })
}
// 分页分类及子分类
export function fetchList(params) {
  return request({
    url: '/productCategory/list',
    method: 'get',
    params
  })
}
// 可删除
export function deleteProductCate(id) {
  return request({
    url: '/productCategory/delete/' + id,
    method: 'post'
  })
}

export function createProductCate(data) {
  return request({
    url: '/productCategory/create',
    method: 'post',
    data: data
  })
}

export function updateProductCate(id, data) {
  return request({
    url: '/productCategory/update/' + id,
    method: 'post',
    data: data
  })
}

export function getProductCate(id) {
  return request({
    url: '/productCategory/' + id,
    method: 'get',
  })
}

export function updateShowStatus(data) {
  return request({
    url: '/productCategory/update/showStatus',
    method: 'post',
    data: data
  })
}

export function updateNavStatus(data) {
  return request({
    url: '/productCategory/update/navStatus',
    method: 'post',
    data: data
  })
}

export function getMchtCategory(params) {
  return request({
    url: '/productCategory/getMchtBusiiCategoryList',
    method: 'post',
    params: params
  })
}

export function getProductClassify(params) {
  return request({
    url: '/mchtPlat/list/sub',
    method: 'post',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/productCate.js